export default __webpack_public_path__ + "static/han-56a048f7558cf59918d7094ac585b80d.png";